import styled from 'styled-components';
import { List } from '@alefeducation/ui-elements-library-core';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  margin-right: 25px;
`;

export const StyledRNPContainer = styled(List)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: ${({ theme: { space } }: any) => `${space[24]}px`};
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
`;

export const StyledTableBody = styled.div`
  height: 100%;

  ol#tablist {
    height: auto;
    margin: 0;
    margin-left: 24px;
  }
`;
